(function(){
  function init(){
    document.querySelectorAll('[data-zabdi-kefir-gallery]').forEach(function(gallery){
      if(gallery.dataset.zabdiKefirReady==='1')return;
      gallery.dataset.zabdiKefirReady='1';
      var main=gallery.querySelector('[data-zabdi-kefir-featured]');
      var thumbs=gallery.querySelectorAll('[data-zabdi-kefir-thumbnail]');
      thumbs.forEach(function(btn){
        btn.addEventListener('click',function(){
          if(!main)return;
          main.src=btn.getAttribute('data-full');
          main.alt=btn.getAttribute('data-alt')||'Imagen Kéfir Zabdi';
          main.classList.toggle('is-packshot',btn.getAttribute('data-kind')==='packshot');
          thumbs.forEach(function(t){t.classList.remove('is-selected');t.setAttribute('aria-pressed','false');});
          btn.classList.add('is-selected');btn.setAttribute('aria-pressed','true');
        });
      });
    });
    var nutritionModal=document.getElementById('zabdi-kefir-nutrition-dialog');
    document.querySelectorAll('[data-zabdi-kefir-open-nutrition]').forEach(function(trigger){
      if(trigger.dataset.zabdiKefirNutritionReady==='1')return;
      trigger.dataset.zabdiKefirNutritionReady='1';
      trigger.addEventListener('click',function(){
        if(!nutritionModal)return;
        if(typeof nutritionModal.showModal==='function')nutritionModal.showModal();
        else {nutritionModal.setAttribute('open','');nutritionModal.focus();}
      });
    });
    if(nutritionModal && nutritionModal.dataset.zabdiKefirReady!=='1'){
      nutritionModal.dataset.zabdiKefirReady='1';
      nutritionModal.querySelectorAll('[data-zabdi-kefir-close-nutrition]').forEach(function(btn){
        btn.addEventListener('click',function(){nutritionModal.close?nutritionModal.close():nutritionModal.removeAttribute('open');});
      });
      nutritionModal.addEventListener('click',function(e){if(e.target===nutritionModal&&nutritionModal.close)nutritionModal.close();});
    }
    var sticky=document.querySelector('[data-zabdi-kefir-sticky-cart]');
    var realBuy=document.querySelector('.zabdi-kefir-product--450 .product-form__submit, .zabdi-kefir-product--1kg .product-form__submit, .zabdi-kefir-product--suero .product-form__submit, .zabdi-kefir-product--pajaritos .product-form__submit');
    var stickyBuy=sticky&&sticky.querySelector('[data-zabdi-kefir-sticky-buy]');
    if(sticky&&realBuy&&stickyBuy&&sticky.dataset.zabdiKefirStickyReady!=='1'){
      sticky.dataset.zabdiKefirStickyReady='1';
      stickyBuy.addEventListener('click',function(){
        if(realBuy.disabled)return;
        realBuy.click();
      });
      var observed=realBuy.closest('.product-form__buttons')||realBuy;
      function syncSticky(){
        stickyBuy.disabled=realBuy.disabled;
        stickyBuy.textContent=realBuy.disabled?'Agotado':'Agregar al carrito';
      }
      syncSticky();
      if(typeof MutationObserver!=='undefined'){
        new MutationObserver(syncSticky).observe(realBuy,{attributes:true,attributeFilter:['disabled']});
      }
      if('IntersectionObserver' in window){
        var stickyObserver=new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            var below=entry.boundingClientRect.bottom<0;
            sticky.classList.toggle('is-visible',!entry.isIntersecting&&below);
          });
        },{threshold:0.06});
        stickyObserver.observe(observed);
      }else{
        function updateSticky(){sticky.classList.toggle('is-visible',observed.getBoundingClientRect().bottom<0);}
        window.addEventListener('scroll',updateSticky,{passive:true});
        updateSticky();
      }
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();